<div class="row question-item mb-3 mb-lg-0" *ngFor="let question of Questions; let index = index; let odd = odd;">
  <app-question-dropdown class="col" *ngIf="isMultipleChoice(question?.type)" [question]="question" 
  [labels]="getQuestionLabels(question)" (answered)="handleAnswer($event)"></app-question-dropdown>
  <dac-question-textbox class="col" *ngIf="isTextbox(question?.type)" [question]="question" (answered)="handleAnswer($event)"></dac-question-textbox>
  <dac-question-checklist class="col" *ngIf="isChecklist(question?.type)" 
  [question]="question" [labels]="getQuestionLabels(question)" (answered)="handleAnswer($event)"></dac-question-checklist>
  <dac-question-single-checkbox class="col" [ngClass]="{'grey lighten-3': odd}" *ngIf="isSingleChoice(question?.type)"
  [question]="question" (answered)="handleAnswer($event)"></dac-question-single-checkbox>
</div>


// WEBPACK FOOTER //
// ./src/app/assessments/question-list-item/question-list-item.component.html